import React from 'react';
import { ArrowLeft, Trash2, RotateCcw } from 'lucide-react';
import EmailCard from './EmailCard';
import { timeAgo } from '../utils/formatters';
import { confirmToast } from '../utils/notify';

export default function TrashAnalyzedView({ items, onBack, onRestore, onDeleteForever, onEmptyTrash }) {
  const sorted = [...items].sort(
    (a, b) => new Date(b.trashedAt || 0) - new Date(a.trashedAt || 0)
  );

  return (
    <div>
      <div style={{ marginBottom: 16, display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 12 }}>
        <button type="button" className="btn" onClick={onBack} style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
          <ArrowLeft size={16} /> Back
        </button>
        <button
          type="button"
          className="btn btn-danger"
          onClick={async () => {
            if (items.length === 0) return;
            const ok = await confirmToast({
              title: `Permanently delete all ${items.length} dismissed item${items.length !== 1 ? 's' : ''}?`,
              description: 'This empties the trash on this device. It cannot be undone.',
              confirmLabel: 'Empty trash',
              danger: true,
            });
            if (ok) onEmptyTrash();
          }}
          disabled={items.length === 0}
          style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}
        >
          <Trash2 size={16} /> Empty trash
        </button>
        <span style={{ color: 'var(--text-dim)', fontSize: '0.9rem' }}>
          {items.length} dismissed analysis item{items.length !== 1 ? 's' : ''} (browser only, not Gmail)
        </span>
      </div>

      <h2 style={{ fontSize: '1.15rem', fontWeight: 700, marginBottom: 8 }}>Trash — dismissed analyses</h2>
      <p style={{ color: 'var(--text-dim)', fontSize: '0.85rem', marginBottom: 16 }}>
        Restore puts the message back into its saved run and combined list (if it was there). Empty trash removes them permanently from this device.
      </p>

      {sorted.length === 0 && (
        <div className="loading-center">
          <span>Trash is empty.</span>
        </div>
      )}

      <div className="email-grid">
        {sorted.map((entry, idx) => (
          <div key={entry.key} style={{ position: 'relative' }}>
            <div
              style={{
                fontSize: '0.72rem',
                color: 'var(--text-dim)',
                marginBottom: 6,
                paddingLeft: 4,
              }}
            >
              Trashed {timeAgo(entry.trashedAt)}
              {entry.sessionTitle ? ` · ${entry.sessionTitle}` : ''}
            </div>
            <EmailCard
              result={entry.result}
              index={idx}
              snoozeLabelId={null}
              trashMode
              onTrashRestore={() => onRestore(entry)}
              onTrashDeleteForever={async () => {
                const ok = await confirmToast({
                  title: 'Delete forever?',
                  description: 'This item will be removed from trash on this device.',
                  confirmLabel: 'Delete',
                  danger: true,
                });
                if (ok) onDeleteForever(entry);
              }}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
